(function () {
  var STATE = { CLOSED: 'closed', BUNDLE: 'bundle', CART: 'cart' };
  var STAGE_DRAWER = 'drawer';

  var root = null;
  var current = STATE.CLOSED;
  var lastFocused = null;

  var dataCache = null;
  var currentCartToken = null;
  var drawerCtrl = null;
  var cartMutationCtrl = null;

  var cartTargets = Object.create(null);
  var cartFlushTimer = null;
  var cartBusy = false;
  var cartLastCart = null;
  var cartErrored = false;
  var pendingOfferRefresh = false;
  var offerRefreshTimer = null;
  var offerRefreshCart = null;

  var seenOffers = new Map();
  var seenImpressions = new Set();
  var bundleSeen = new Map();
  var bundleSelectedIds = new Set();

  var impressionObserver = null;

  var lastConfig = null;
  var lastShipping = null;
  var variantCompareCache = Object.create(null);
  var dealHintDone = false;
  var bundleBadgePulseDone = false;
  var cartHadItems = false;
  var bundleAwaitingFresh = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function cartTitle(count) {
    var lang = ((window.MGMFunnel && MGMFunnel.locale) || 'fr').toLowerCase().split('-')[0];
    var n = count || 0;
    if (lang === 'fr') return 'Votre panier (' + n + ' article' + (n !== 1 ? 's' : '') + ')';
    return 'Your Cart (' + n + ' item' + (n !== 1 ? 's' : '') + ')';
  }

  function savingsLabel(amount, currency) {
    var lang = ((window.MGMFunnel && MGMFunnel.locale) || 'fr').toLowerCase().split('-')[0];
    var formatted = MGMFunnel.formatPrice(amount, currency);
    if (lang === 'fr') return 'Vous économisez ' + formatted;
    return 'You save ' + formatted;
  }

  function giftLabels() {
    var lang = ((window.MGMFunnel && MGMFunnel.locale) || 'fr').toLowerCase().split('-')[0];
    if (lang === 'fr') return { badge: 'Cadeau', price: 'Offert' };
    return { badge: 'Gift', price: 'Free' };
  }

  function giftCents(cart) {
    return (window.MGMGift && cart) ? MGMGift.giftDiscountCents(cart) : 0;
  }

  function setField(name, value, scope) {
    var target = (scope || root).querySelector('[data-mgm-field="' + name + '"]');
    if (!target) return;
    if (target.tagName === 'IMG') {
      var src = value || '';
      if (target.getAttribute('src') !== src) target.setAttribute('src', src);
      if (!target.alt) target.alt = '';
    } else {
      var v = value == null ? '' : String(value);
      if (target.textContent !== v) target.textContent = v;
    }
  }

  function offersNotInCart(offers, cart) {
    if (!offers || !offers.length) return [];
    var inCart = Object.create(null);
    ((cart && cart.items) || []).forEach(function (i) { inCart[String(i.variant_id)] = true; });
    return offers.filter(function (o) { return !inCart[String(o.variant_id)]; });
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function mdInline(text) {
    var t = escHtml(text);
    t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    t = t.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    t = t.replace(/__([^_]+)__/g, '<strong>$1</strong>');
    t = t.replace(/(^|[^*])\*([^*]+)\*/g, '$1<em>$2</em>');
    t = t.replace(/(^|[^_])_([^_]+)_/g, '$1<em>$2</em>');
    return t;
  }

  function renderMarkdown(md) {
    if (!md) return '';
    var src = String(md)
      .replace(/\\r\\n|\\n|\\r/g, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/\r\n?/g, '\n');
    var lines = src.split('\n');
    var html = [];
    var listType = null;
    var para = [];

    function flushPara() {
      if (para.length) { html.push('<p>' + mdInline(para.join('\n')).replace(/\n/g, '<br>') + '</p>'); para = []; }
    }
    function closeList() {
      if (listType) { html.push('</' + listType + '>'); listType = null; }
    }

    lines.forEach(function (raw) {
      var line = raw.trim();
      if (!line) { flushPara(); closeList(); return; }

      var h = /^(#{1,3})\s+(.*)$/.exec(line);
      if (h) {
        flushPara(); closeList();
        var tag = h[1].length === 1 ? 'h4' : (h[1].length === 2 ? 'h5' : 'h6');
        html.push('<' + tag + '>' + mdInline(h[2]) + '</' + tag + '>');
        return;
      }

      var ul = /^[-*]\s+(.*)$/.exec(line);
      var ol = /^\d+\.\s+(.*)$/.exec(line);
      if (ul || ol) {
        flushPara();
        var want = ul ? 'ul' : 'ol';
        if (listType && listType !== want) closeList();
        if (!listType) { listType = want; html.push('<' + want + '>'); }
        html.push('<li>' + mdInline(ul ? ul[1] : ol[1]) + '</li>');
        return;
      }

      closeList();
      para.push(line);
    });

    flushPara(); closeList();
    return html.join('');
  }

  function collapseRemove(node) {
    if (!node || node.classList.contains('is-removing')) return;
    node.classList.add('is-removing');
    var h = node.offsetHeight;
    node.style.height = h + 'px';
    void node.offsetHeight;
    node.style.height = '0px';
    node.style.opacity = '0';
    node.style.marginTop = '0px';
    node.style.marginBottom = '0px';
    node.style.paddingTop = '0px';
    node.style.paddingBottom = '0px';
    var done = function () {
      node.removeEventListener('transitionend', done);
      if (node.parentNode) node.parentNode.removeChild(node);
    };
    node.addEventListener('transitionend', done);
    setTimeout(done, 400);
  }

  function reconcile(list, items, keyOf, build, fill) {
    var existing = Object.create(null);
    $$('[data-recon-key]', list).forEach(function (n) {
      if (n.classList.contains('is-removing')) return;
      existing[n.getAttribute('data-recon-key')] = n;
    });

    var seen = Object.create(null);
    var prev = null;
    items.forEach(function (item) {
      var key = String(keyOf(item));
      seen[key] = true;
      var node = existing[key];
      if (!node) {
        node = build(item);
        if (!node) return;
        node.setAttribute('data-recon-key', key);
      }
      if (fill) fill(node, item);
      var ref = prev ? prev.nextSibling : list.firstChild;
      if (node !== ref) list.insertBefore(node, ref);
      prev = node;
    });

    $$('[data-recon-key]', list).forEach(function (n) {
      if (n.classList.contains('is-removing')) return;
      if (n.hasAttribute('data-optimistic')) return;
      if (!seen[n.getAttribute('data-recon-key')]) onReconRemove(n);
    });
  }

  function onReconRemove(node) {
    var oid = node.getAttribute('data-offer-id');
    if (oid) {
      var io = getImpressionObserver();
      if (io) io.unobserve(node);
      seenOffers.delete(oid);
    }
    if (node.parentNode) node.parentNode.removeChild(node);
  }

  function getImpressionObserver() {
    if (!impressionObserver && 'IntersectionObserver' in window) {
      impressionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var oid = entry.target.getAttribute('data-offer-id');
          if (!oid || seenImpressions.has(oid)) return;
          seenImpressions.add(oid);
          var offer = seenOffers.get(oid);
          if (offer && currentCartToken) {
            MGMFunnel.event(currentCartToken, offer, STAGE_DRAWER, 'impression', 0);
          }
        });
      }, { threshold: 0.5 });
    }
    return impressionObserver;
  }

  function registerOffer(node, offer) {
    var oid = String(offer.offer_id);
    node.setAttribute('data-offer-id', oid);
    seenOffers.set(oid, offer);
    var io = getImpressionObserver();
    if (io) io.observe(node);
  }

  function clearOfferTracking() {
    var io = getImpressionObserver();
    if (io) {
      seenOffers.forEach(function (_, oid) {
        var node = root.querySelector('[data-offer-id="' + oid + '"]');
        if (node) io.unobserve(node);
      });
    }
    seenOffers.clear();
    seenImpressions.clear();
    bundleSeen.clear();
    bundleSelectedIds.clear();
  }

  function applyConfig(config) {
    config = config || {};
    setField('bundle_title', config.bundle_title);
    setField('bundle_subtitle', config.bundle_subtitle);
    setField('bundle_cta_label', config.bundle_cta_label);
    setField('deals_title', config.deals_title);
    setField('deals_subtitle', config.deals_subtitle);
    setField('cart_cta_label', config.cart_cta_label);
    setField('empty_cart_text', config.empty_cart_text);
  }

  function buildBundleItem(offer, config) {
    var tpl = $('[data-mgm-tpl="bundle-item"]', root);
    if (!tpl) return null;
    var addLabel = (config && config.add_label) || '+ Add';
    var node = tpl.content.firstElementChild.cloneNode(true);

    if (offer.discount_pct) {
      var badge = node.querySelector('[data-mgm-field="badge"]');
      if (badge) {
        badge.textContent = '-' + offer.discount_pct + '%';
        badge.hidden = false;
      }
    }

    setField('image', offer.image, node);
    var img = node.querySelector('img[data-mgm-field="image"]');
    if (img) img.alt = offer.title || '';
    setField('title', offer.title, node);
    setField('description', offer.description, node);
    setField('compare_price', MGMFunnel.formatPrice(offer.compare_price, offer.currency), node);
    setField('price', MGMFunnel.formatPrice(offer.price, offer.currency), node);
    setField('cta_label', offer.cta_label || addLabel, node);
    return node;
  }

  function normalizeTitle(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function pageUpsellPrices() {
    var map = Object.create(null);
    $$('.mgm-upsell-card').forEach(function (card) {
      var titleEl = card.querySelector('.mgm-upsell-card__title');
      var priceEl = card.querySelector('.mgm-upsell-card__price');
      var title = titleEl ? normalizeTitle(titleEl.textContent) : '';
      var price = priceEl && priceEl.textContent ? priceEl.textContent.trim() : (card.getAttribute('data-upsell-price') || '').trim();
      if (title && price) map[title] = price;
    });
    return map;
  }

  function setBundlePagePrice(node, offer, pageMap) {
    var el = node.querySelector('[data-mgm-field="page_price"]');
    if (!el) return;
    var price = pageMap[normalizeTitle(offer.title)];
    if (price) {
      if (el.textContent !== price) el.textContent = price;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function maybePulseBadges() {
    if (bundleBadgePulseDone || current !== STATE.BUNDLE) return;
    var badges = $$('[data-mgm-bundle-list] .mgm-cart-bundle-item__badge', root).filter(function (b) {
      return !b.hidden && b.offsetParent !== null;
    });
    if (!badges.length) return;
    bundleBadgePulseDone = true;
    badges.forEach(function (b) {
      b.classList.add('is-pulse');
      var clear = function () {
        b.classList.remove('is-pulse');
        b.removeEventListener('animationend', clear);
      };
      b.addEventListener('animationend', clear);
      setTimeout(clear, 4000);
    });
  }

  function offerCartLine(offer, cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(offer.variant_id)) return items[i];
    }
    return null;
  }

  function setBundleSelected(node, selected) {
    node.setAttribute('data-selected', selected ? 'true' : 'false');
    var btn = node.querySelector('[data-mgm-action="add"]');
    if (!btn) return;
    btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    btn.classList.toggle('is-added', selected);
    var label = btn.querySelector('[data-mgm-field="cta_label"]');
    if (!label) return;
    if (selected) {
      if (!btn.hasAttribute('data-label-add')) btn.setAttribute('data-label-add', label.textContent);
      var sel = btn.getAttribute('data-label-selected') || 'Ajouté';
      if (label.textContent !== sel) label.textContent = sel;
    } else {
      var add = btn.getAttribute('data-label-add');
      if (add != null && label.textContent !== add) label.textContent = add;
    }
  }

  function buildBundleSkeleton() {
    var tpl = $('[data-mgm-tpl="bundle-item"]', root);
    if (!tpl) return null;
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.classList.add('is-skeleton');
    node.setAttribute('data-mgm-skeleton', '');
    return node;
  }

  function showBundleSkeleton() {
    var list = $('[data-mgm-bundle-list]', root);
    if (!list) return;
    if (list.querySelector('[data-mgm-skeleton]')) return;
    list.innerHTML = '';
    for (var i = 0; i < 2; i++) {
      var s = buildBundleSkeleton();
      if (s) list.appendChild(s);
    }
  }

  function renderBundle(bundle, config, cart, fresh) {
    var list = $('[data-mgm-bundle-list]', root);
    var stateEl = $('[data-cart-state-view="bundle"]', root);
    if (!list || !stateEl) return;

    if (bundleAwaitingFresh && !fresh) { showBundleSkeleton(); return; }
    $$('[data-mgm-skeleton]', list).forEach(function (n) { n.remove(); });
    if (fresh) bundleAwaitingFresh = false;

    var showBundle = bundle && bundle.show !== false;
    var payloadIds = Object.create(null);
    if (showBundle && bundle.offers) {
      bundle.offers.forEach(function (o) {
        var id = String(o.offer_id);
        payloadIds[id] = true;
        bundleSeen.set(id, o);
      });
    }
    var offers = [];
    if (showBundle) {
      bundleSeen.forEach(function (o, id) {
        if (payloadIds[id] || bundleSelectedIds.has(id)) offers.push(o);
      });
    }

    var pageMap = pageUpsellPrices();

    reconcile(list, offers,
      function (o) { return o.offer_id; },
      function (offer) { return buildBundleItem(offer, config); },
      function (node, offer) {
        registerOffer(node, offer);
        setBundlePagePrice(node, offer, pageMap);
        if (node.__mgmPending) return;
        var line = offerCartLine(offer, cart);
        setBundleSelected(node, !!line);
        if (line) node.setAttribute('data-line-key', String(line.key));
        else node.removeAttribute('data-line-key');
      }
    );

    if (offers.length === 0 && current === STATE.BUNDLE) setView(STATE.CART);
    maybePulseBadges();
  }

  function buildDealItem(deal, config) {
    var tpl = $('[data-mgm-tpl="deal"]', root);
    var benefitTpl = $('[data-mgm-tpl="deal-benefit"]', root);
    var tabBtnTpl = $('[data-mgm-tpl="deal-tab-button"]', root);
    var quoteTpl = $('[data-mgm-tpl="deal-panel-quote"]', root);
    var textTpl = $('[data-mgm-tpl="deal-panel-text"]', root);
    if (!tpl) return null;
    var addLabel = (config && config.add_label) || '+ Add';

    var node = tpl.content.firstElementChild.cloneNode(true);

    if (deal.discount_pct) {
      var badge = node.querySelector('[data-mgm-field="badge"]');
      if (badge) {
        badge.textContent = '-' + deal.discount_pct + '%';
        badge.hidden = false;
      }
    }

    setField('image', deal.image, node);
    var img = node.querySelector('img[data-mgm-field="image"]');
    if (img) img.alt = deal.title || '';
    setField('title', deal.title, node);
    var dealLink = node.querySelector('[data-deal-link]');
    if (dealLink) {
      var dealUrl = deal.handle ? '/products/' + deal.handle : (deal.url || '');
      if (dealUrl) dealLink.setAttribute('href', dealUrl);
      else dealLink.removeAttribute('href');
    }
    setField('description', deal.description, node);
    setField('compare_price', MGMFunnel.formatPrice(deal.compare_price, deal.currency), node);
    setField('price', MGMFunnel.formatPrice(deal.price, deal.currency), node);
    setField('cta_label', deal.cta_label || addLabel, node);

    var hasBenefits = deal.key_benefits && deal.key_benefits.length > 0;
    var hasTabs = deal.detail_tabs && deal.detail_tabs.length > 0;

    if (hasBenefits) {
      var benefitsWrap = node.querySelector('[data-mgm-benefits]');
      if (benefitsWrap && benefitTpl) {
        deal.key_benefits.forEach(function (b) {
          var bNode = benefitTpl.content.firstElementChild.cloneNode(true);
          setField('text', b, bNode);
          benefitsWrap.appendChild(bNode);
        });
        benefitsWrap.hidden = false;
      }
    }

    if (hasTabs) {
      var tabsWrap = node.querySelector('[data-mgm-tabs]');
      var tablist = node.querySelector('[data-mgm-tablist]');
      var panelsWrap = node.querySelector('[data-mgm-panels]');
      if (tabsWrap && tablist && panelsWrap) {
        deal.detail_tabs.forEach(function (tab, idx) {
          var tabId = 't' + idx;

          var btn = tabBtnTpl.content.firstElementChild.cloneNode(true);
          setField('label', tab.label, btn);
          btn.setAttribute('data-deal-tab', tabId);
          if (idx === 0) btn.setAttribute('aria-selected', 'true');
          tablist.appendChild(btn);

          var panelTpl = (tab.layout === 'quote') ? quoteTpl : textTpl;
          if (!panelTpl) return;
          var panel = panelTpl.content.firstElementChild.cloneNode(true);
          panel.setAttribute('data-deal-panel', tabId);
          if (idx === 0) panel.removeAttribute('hidden');

          if (tab.layout === 'quote') {
            var quoteEl = panel.querySelector('[data-mgm-field="quote"]');
            if (quoteEl) quoteEl.innerHTML = renderMarkdown(tab.quote);
            setField('author_name', tab.author_name, panel);
            setField('author_role', tab.author_role, panel);
            if (tab.author_image_url) setField('author_image', tab.author_image_url, panel);
          } else {
            var bodyEl = panel.querySelector('[data-mgm-field="body"]');
            if (bodyEl) bodyEl.innerHTML = renderMarkdown(tab.body);
          }
          panelsWrap.appendChild(panel);
        });
        tabsWrap.hidden = false;
      }
    }

    if (hasBenefits || hasTabs) {
      var toggle = node.querySelector('[data-deal-toggle]');
      if (toggle) toggle.hidden = false;
    }

    return node;
  }

  function renderDeals(deals, config, cart) {
    var wrapper = $('[data-cart-module="exclusive-deals"]', root);
    var list = $('[data-mgm-deals-list]', root);
    if (!wrapper || !list) return;

    if (cart && cart.item_count > 0) cartHadItems = true;
    var cartEmpty = !cart || !cart.item_count;

    var offers = offersNotInCart(deals, cart);

    reconcile(list, offers,
      function (d) { return d.offer_id; },
      function (deal) { return buildDealItem(deal, config); },
      function (node, deal) { registerOffer(node, deal); }
    );

    var visibleCount = $$('[data-recon-key]', list).filter(function (n) {
      return !n.classList.contains('is-removing');
    }).length;
    wrapper.hidden = visibleCount === 0 || (cartEmpty && !cartHadItems);

    maybeHintDeals();
  }

  function maybeHintDeals() {
    if (dealHintDone || current !== STATE.CART) return;
    var toggles = $$('[data-mgm-deals-list] [data-deal-toggle]', root).filter(function (t) {
      return !t.hidden && t.offsetParent !== null;
    });
    if (!toggles.length) return;
    dealHintDone = true;
    setTimeout(function () {
      toggles.forEach(function (t) {
        if (t.closest('[data-deal-open="true"]')) return;
        t.classList.add('is-hint');
        var clear = function () {
          t.classList.remove('is-hint');
          t.removeEventListener('animationend', clear);
        };
        t.addEventListener('animationend', clear);
        setTimeout(clear, 4000);
      });
    }, 500);
  }

  function renderShipping(shipping, config) {
    var wrap = $('[data-mgm-module="progress"]', root);
    if (!wrap) return;

    if (!shipping || !config) {
      wrap.hidden = true;
      return;
    }

    // Aucun seuil de livraison gratuite configuré pour la devise du panier → masquer la barre
    if (shipping.applies === false) {
      wrap.hidden = true;
      return;
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var shippingCurrency = shipping.currency || config.currency;
    var value = MGMFunnel.formatPrice(config.free_shipping_value, shippingCurrency);
    var label;
    if (shipping.qualifies_free) {
      label = esc(MGMFunnel.template(config.shipping_unlocked_template, { value: value }));
    } else {
      var amountBold = '<strong>' + esc(MGMFunnel.formatPrice(shipping.amount_away, shippingCurrency)) + '</strong>';
      var rawTpl = String(config.shipping_progress_template || '');
      label = rawTpl
        .replace(/\{amount\}/g, amountBold)
        .replace(/\{value\}/g, esc(value));
    }

    var labelEl = root.querySelector('[data-mgm-field="shipping_label"]');
    if (labelEl && labelEl.innerHTML !== label) labelEl.innerHTML = label;

    var pct = 0;
    if (shipping.qualifies_free) {
      pct = 100;
    } else if (shipping.threshold > 0) {
      pct = Math.min(1, Math.max(0, shipping.current_total / shipping.threshold)) * 100;
    }
    var fill = $('[data-mgm-progress-fill]', root);
    var pctStr = pct + '%';
    if (fill && fill.style.width !== pctStr) fill.style.width = pctStr;

    wrap.hidden = false;
  }

  function fillLineItem(node, item) {
    node.setAttribute('data-line-key', item.key);

    var imgUrl = item.image || (item.featured_image && item.featured_image.url) || '';
    setField('image', imgUrl, node);
    var img = node.querySelector('img[data-mgm-field="image"]');
    if (img && !img.alt) img.alt = item.product_title || item.title || '';

    setField('title', item.product_title || item.title, node);

    var sub = node.querySelector('[data-mgm-field="subtitle"]');
    if (sub) {
      if (item.variant_title && item.variant_title !== 'Default Title') {
        setField('subtitle', item.variant_title, node);
        sub.hidden = false;
      } else {
        sub.hidden = true;
      }
    }

    setField('quantity', String(item.quantity), node);
    var qtyWrap = node.querySelector('.mgm-cart-qty');
    if (qtyWrap) qtyWrap.setAttribute('data-qty', String(item.quantity));

    var currency = item.currency || (window.Shopify && Shopify.currency && Shopify.currency.active);
    var finalCents = item.final_line_price != null ? item.final_line_price : item.line_price;
    var originalCents = item.original_line_price != null ? item.original_line_price : finalCents;

    var q = item.quantity || 1;
    node.setAttribute('data-unit-final', String(Math.round(finalCents / q)));
    node.setAttribute('data-unit-original', String(Math.round(originalCents / q)));
    node.setAttribute('data-currency', currency || '');

    var isGift = window.MGMGift && MGMGift.isGiftItem(item);
    node.classList.toggle('mgm-cart-line-item--gift', !!isGift);
    var badgeEl = node.querySelector('[data-mgm-field="gift_badge"]');
    var noteEl = node.querySelector('[data-mgm-field="gift_note"]');
    var incBtn = node.querySelector('[data-cart-qty="inc"]');
    var decBtn = node.querySelector('[data-cart-qty="dec"]');

    if (isGift) {
      var labels = giftLabels();
      node.setAttribute('data-gift-ns', MGMGift.giftNamespace(item));
      // Le passage à 0 € se fait au checkout (code BXGY) : on affiche la
      // ligne comme offerte et on l'exclut des totaux affichés.
      node.setAttribute('data-unit-final', '0');
      // Libellé court (property « Cadeau ») à la place du titre produit
      // complet, pour une ligne compacte.
      var giftTitle = (item.properties && item.properties['Cadeau']) || item.product_title || item.title;
      setField('title', giftTitle, node);
      if (sub) sub.hidden = true;
      if (badgeEl) { badgeEl.textContent = labels.badge; badgeEl.hidden = false; }
      if (noteEl) noteEl.hidden = true;
      if (incBtn) incBtn.hidden = true;
      if (decBtn) decBtn.hidden = true;
      var giftCompareEl = node.querySelector('[data-mgm-field="line_compare"]');
      if (giftCompareEl) {
        // originalCents : prix catalogue même quand la remise BXGY est déjà
        // allouée par l'API Cart (final_line_price passe alors à 0).
        setField('line_compare', MGMFunnel.formatPrice(Math.max(originalCents, finalCents) / 100, currency), node);
        giftCompareEl.hidden = false;
      }
      var giftSavingsEl = node.querySelector('[data-mgm-field="line_savings"]');
      if (giftSavingsEl) giftSavingsEl.hidden = true;
      setField('line_price', labels.price, node);
      return;
    }

    node.removeAttribute('data-gift-ns');
    if (badgeEl) badgeEl.hidden = true;
    if (noteEl) noteEl.hidden = true;
    if (incBtn) incBtn.hidden = false;
    if (decBtn) decBtn.hidden = false;
    setField('line_price', MGMFunnel.formatPrice(finalCents / 100, currency), node);
    setLineCompareAndSavings(node, originalCents, finalCents, currency);
    applyVariantCompare(node, item, finalCents, currency);
  }

  function setLineCompareAndSavings(node, compareCents, finalCents, currency) {
    var savingsCents = Math.max(0, compareCents - finalCents);

    var compareEl = node.querySelector('[data-mgm-field="line_compare"]');
    if (compareEl) {
      if (savingsCents > 0) {
        setField('line_compare', MGMFunnel.formatPrice(compareCents / 100, currency), node);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var savingsEl = node.querySelector('[data-mgm-field="line_savings"]');
    if (savingsEl) {
      if (savingsCents > 0) {
        setField('line_savings', savingsLabel(savingsCents / 100, currency), node);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
  }

  function getVariantCompare(handle, variantId) {
    if (!handle) return Promise.resolve(null);
    if (!variantCompareCache[handle]) {
      variantCompareCache[handle] = MGMFunnel.product(handle).catch(function () { return null; });
    }
    return variantCompareCache[handle].then(function (product) {
      if (!product || !product.variants) return null;
      var match = null;
      product.variants.forEach(function (v) {
        if (String(v.id) === String(variantId)) match = v;
      });
      return match && match.compare_at_price ? match.compare_at_price : null;
    });
  }

  function applyVariantCompare(node, item, finalCents, currency) {
    if (!item.handle || !item.variant_id) return;
    getVariantCompare(item.handle, item.variant_id).then(function (comparePerUnit) {
      if (!comparePerUnit) return;
      if (node.getAttribute('data-line-key') !== String(item.key)) return;
      var originalCents = item.original_line_price != null ? item.original_line_price : finalCents;
      var bestCompare = Math.max(comparePerUnit * (item.quantity || 1), originalCents);
      if (bestCompare > finalCents) {
        setLineCompareAndSavings(node, bestCompare, finalCents, currency);
      }
    });
  }

  function renderLineItems(items, config) {
    var list = $('[data-mgm-line-items]', root);
    var empty = $('[data-mgm-cart-empty]', root);
    if (!list) return;

    var hasItems = items && items.length > 0;

    if (!hasItems) {
      $$('[data-line-item]', list).forEach(function (n) {
        if (!n.classList.contains('is-removing')) collapseRemove(n);
      });
      if (empty) {
        setField('empty_cart_text', (config && config.empty_cart_text) || 'Votre panier est vide');
        empty.hidden = false;
      }
      list.hidden = !list.querySelector('[data-line-item]');
      return;
    }

    list.hidden = false;
    if (empty) empty.hidden = true;

    var tpl = $('[data-mgm-tpl="line-item"]', root);
    if (!tpl) return;

    reconcile(list, items,
      function (i) { return i.key; },
      function () { return tpl.content.firstElementChild.cloneNode(true); },
      fillLineItem
    );
  }

  function setCheckoutEnabled(enabled) {
    var cta = $('[data-cart-checkout]', root);
    if (!cta) return;
    cta.classList.toggle('is-disabled', !enabled);
    if (enabled) {
      cta.removeAttribute('aria-disabled');
      cta.removeAttribute('tabindex');
    } else {
      cta.setAttribute('aria-disabled', 'true');
      cta.setAttribute('tabindex', '-1');
    }
  }

  function updateHeaderCartCount(count) {
    var n = count || 0;
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = n;
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    var btn = document.querySelector('.brand-header__cart');
    if (btn) btn.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }

  function updateCartHeader(cart) {
    if (!cart) return;
    if (cart.item_count > 0) cartHadItems = true;
    setField('cart_title', cartTitle(cart.item_count));
    setField('cart_subtotal', MGMFunnel.formatPrice(((cart.total_price || 0) - giftCents(cart)) / 100, cart.currency));
    setCheckoutEnabled(cart.item_count > 0);
    updateHeaderCartCount(cart.item_count);
  }

  function renderAll(result, fresh) {
    if (!result) return;
    var cart = result.cart;
    lastConfig = result.drawer.config;
    lastShipping = result.drawer.shipping;
    applyConfig(result.drawer.config);
    renderBundle(result.drawer.bundle, result.drawer.config, cart, fresh);
    renderDeals(result.drawer.deals, result.drawer.config, cart);
    renderShipping(result.drawer.shipping, result.drawer.config);
    renderLineItems(cart.items, result.drawer.config);
    updateCartHeader(cart);
    setLoading(false);
  }

  var FALLBACK_CONFIG = {
    bundle_title: '',
    bundle_subtitle: '',
    bundle_cta_label: 'Continuer',
    deals_title: '',
    deals_subtitle: '',
    cart_cta_label: 'Commander',
    add_label: '+ Add',
    empty_cart_text: 'Votre panier est vide'
  };

  function renderFallback(cart) {
    bundleAwaitingFresh = false;
    applyConfig(FALLBACK_CONFIG);
    var bundleList = $('[data-mgm-bundle-list]', root);
    if (bundleList) bundleList.innerHTML = '';
    var dealsWrap = $('[data-cart-module="exclusive-deals"]', root);
    if (dealsWrap) dealsWrap.hidden = true;
    var shippingWrap = $('[data-mgm-module="progress"]', root);
    if (shippingWrap) shippingWrap.hidden = true;
    if (cart) {
      renderLineItems(cart.items, FALLBACK_CONFIG);
      updateCartHeader(cart);
      currentCartToken = cart.token;
    }
    if (current === STATE.BUNDLE) setView(STATE.CART);
    setLoading(false);
  }

  var prefetchPromise = null;

  function pageContextProducts() {
    var out = [];
    $$('[data-upsell-product-id]').forEach(function (n) {
      var id = n.getAttribute('data-upsell-product-id');
      if (id && out.indexOf(id) === -1) out.push(id);
    });
    return out;
  }

  function prefetch() {
    if (dataCache || prefetchPromise) return prefetchPromise;
    prefetchPromise = MGMFunnel.cart().then(function (cart) {
      return MGMFunnel.drawer({ cart: cart, contextProducts: pageContextProducts() }).then(function (result) {
        dataCache = result;
        currentCartToken = result.cart.token;
      });
    }).catch(function () {}).then(function () {
      prefetchPromise = null;
    });
    return prefetchPromise;
  }

  function hydrate(opts) {
    opts = opts || {};
    if (!root) return;

    if (!opts.silent) {
      if (dataCache) {
        renderAll(dataCache, false);
      } else if (prefetchPromise) {
        prefetchPromise.then(function () {
          if (root.classList.contains('is-open')) hydrate();
        });
        return;
      }
    }

    if (drawerCtrl) drawerCtrl.abort();
    drawerCtrl = new AbortController();
    var sig = drawerCtrl.signal;

    MGMFunnel.cart({ signal: sig }).then(function (cart) {
      if (sig.aborted) return;
      var giftPromise = window.MGMGift
        ? MGMGift.sync(cart).then(function (r) { return (r && r.cart) || cart; }).catch(function () { return cart; })
        : Promise.resolve(cart);
      return giftPromise.then(function (syncedCart) {
        if (sig.aborted) return;
        return MGMFunnel.drawer({ signal: sig, cart: syncedCart }).then(function (result) {
          if (sig.aborted) return;
          dataCache = result;
          currentCartToken = result.cart.token;
          renderAll(result, true);
        }).catch(function (e) {
          if (e && e.name === 'AbortError') return;
          console.warn('[MGM drawer] API failed, fallback', e);
          renderFallback(syncedCart);
        });
      });
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      console.warn('[MGM] /cart.js failed', e);
      setLoading(false);
    });
  }

  function setView(state) {
    if (!root) return;
    if (state === STATE.CLOSED) return;
    current = state;
    root.setAttribute('data-cart-state', state);
    $$('[data-cart-state-view]', root).forEach(function (el) {
      var view = el.getAttribute('data-cart-state-view');
      if (view === state) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    if (state === STATE.CART) maybeHintDeals();
    if (state === STATE.BUNDLE) maybePulseBadges();
  }

  function setLoading(on) {
    if (root) root.classList.toggle('is-loading', !!on);
  }

  function open(state) {
    if (!root) return;
    dealHintDone = false;
    bundleBadgePulseDone = false;
    bundleSeen.clear();
    bundleSelectedIds.clear();
    lastFocused = document.activeElement;
    if (state) setView(state);
    else setView(current === STATE.CLOSED ? (root.getAttribute('data-cart-state') || STATE.BUNDLE) : current);
    bundleAwaitingFresh = current === STATE.BUNDLE;
    if (bundleAwaitingFresh) showBundleSkeleton();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setLoading(!dataCache);
    hydrate();
  }

  function close() {
    if (!root) return;
    clearOfferTracking();
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    current = STATE.CLOSED;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  function updateQtyUI(item, next) {
    var valueEl = $('[data-cart-qty-value]', item);
    if (!valueEl) return;
    valueEl.textContent = next;
    var qtyWrap = valueEl.closest('.mgm-cart-qty');
    if (qtyWrap) qtyWrap.setAttribute('data-qty', String(next));
  }

  function renderCartImmediate(cart) {
    if (!cart) return;
    currentCartToken = cart.token;
    renderLineItems(cart.items, lastConfig || FALLBACK_CONFIG);
    updateCartHeader(cart);
  }

  function shippingFromTotalCents(totalCents) {
    if (!lastShipping || !lastConfig) return;
    var threshold = lastShipping.threshold;
    var totalUnits = (totalCents || 0) / 100;
    var qualifies = threshold > 0 ? totalUnits >= threshold : !!lastShipping.qualifies_free;
    var amountAway = threshold > 0 ? Math.max(0, threshold - totalUnits) : 0;
    renderShipping({
      applies: lastShipping.applies,
      threshold: threshold,
      current_total: totalUnits,
      qualifies_free: qualifies,
      amount_away: amountAway,
      currency: lastShipping.currency
    }, lastConfig);
  }

  function updateShippingFromCart(cart) {
    if (cart) shippingFromTotalCents((cart.total_price || 0) - giftCents(cart));
  }

  function recomputeTotalsOptimistic() {
    var list = $('[data-mgm-line-items]', root);
    if (!list) return;
    var totalCents = 0, totalQty = 0, currency;
    $$('[data-line-item]', list).forEach(function (n) {
      if (n.classList.contains('is-removing')) return;
      var qEl = $('[data-cart-qty-value]', n);
      var qv = qEl ? (parseInt(qEl.textContent, 10) || 0) : 0;
      totalQty += qv;
      var uf = parseInt(n.getAttribute('data-unit-final'), 10);
      if (!isNaN(uf)) totalCents += uf * qv;
      if (!currency) currency = n.getAttribute('data-currency') || undefined;
    });
    setField('cart_subtotal', MGMFunnel.formatPrice(totalCents / 100, currency));
    setField('cart_title', cartTitle(totalQty));
    if (totalQty > 0) cartHadItems = true;
    setCheckoutEnabled(totalQty > 0);
    updateHeaderCartCount(totalQty);
    shippingFromTotalCents(totalCents);
  }

  function optimisticLinePrice(node, newQty) {
    var unitFinal = parseInt(node.getAttribute('data-unit-final'), 10);
    if (isNaN(unitFinal)) return;
    var unitOriginal = parseInt(node.getAttribute('data-unit-original'), 10);
    if (isNaN(unitOriginal)) unitOriginal = unitFinal;
    var currency = node.getAttribute('data-currency') || undefined;
    var finalCents = unitFinal * newQty;
    setField('line_price', MGMFunnel.formatPrice(finalCents / 100, currency), node);
    setLineCompareAndSavings(node, unitOriginal * newQty, finalCents, currency);
  }

  function doOfferRefresh(cart) {
    if (!root || !root.classList.contains('is-open')) return;
    if (drawerCtrl) drawerCtrl.abort();
    drawerCtrl = new AbortController();
    var sig = drawerCtrl.signal;
    var cartPromise = cart ? Promise.resolve(cart) : MGMFunnel.cart({ signal: sig });
    cartPromise.then(function (c) {
      if (sig.aborted) return;
      return MGMFunnel.drawer({ signal: sig, cart: c }).then(function (result) {
        if (sig.aborted) return;
        dataCache = result;
        lastConfig = result.drawer.config;
        lastShipping = result.drawer.shipping;
        renderBundle(result.drawer.bundle, result.drawer.config, c, true);
        renderDeals(result.drawer.deals, result.drawer.config, c);
      });
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      console.warn('[MGM] offer refresh failed', e);
    });
  }

  function scheduleOfferRefresh(cart) {
    if (cart) offerRefreshCart = cart;
    if (offerRefreshTimer) clearTimeout(offerRefreshTimer);
    offerRefreshTimer = setTimeout(function () {
      offerRefreshTimer = null;
      var c = offerRefreshCart;
      offerRefreshCart = null;
      doOfferRefresh(c);
    }, 300);
  }

  function cartIdle() {
    return !cartBusy && !cartFlushTimer && Object.keys(cartTargets).length === 0;
  }

  function queueCartChange(lineKey, quantity, refreshOffers) {
    var prev = cartTargets[lineKey];
    cartTargets[lineKey] = {
      quantity: quantity,
      refreshOffers: !!refreshOffers || (prev && prev.refreshOffers) || false
    };
    if (cartFlushTimer) clearTimeout(cartFlushTimer);
    cartFlushTimer = setTimeout(flushCart, 250);
  }

  function flushCart() {
    cartFlushTimer = null;
    if (cartBusy) return;
    var keys = Object.keys(cartTargets);
    if (!keys.length) return;
    var key = keys[0];
    var target = cartTargets[key];
    delete cartTargets[key];
    if (target.refreshOffers) pendingOfferRefresh = true;
    cartBusy = true;
    MGMFunnel.changeLine(key, target.quantity)
      .then(function (cart) {
        cartLastCart = cart;
      })
      .catch(function (e) {
        console.warn('[MGM] cart change failed', e);
        cartErrored = true;
      })
      .then(function () {
        cartBusy = false;
        if (Object.keys(cartTargets).length) {
          flushCart();
          return;
        }
        if (cartErrored) {
          cartErrored = false;
          pendingOfferRefresh = false;
          hydrate({ silent: true });
          return;
        }
        if (cartLastCart) {
          renderCartImmediate(cartLastCart);
          updateShippingFromCart(cartLastCart);
          if (window.MGMGift) {
            MGMGift.sync(cartLastCart).then(function (r) {
              if (r && r.changed && r.cart) {
                renderCartImmediate(r.cart);
                updateShippingFromCart(r.cart);
              }
            });
          }
        }
        if (pendingOfferRefresh) {
          pendingOfferRefresh = false;
          scheduleOfferRefresh(cartLastCart);
        }
      });
  }

  function flushCartNow() {
    if (cartFlushTimer) { clearTimeout(cartFlushTimer); cartFlushTimer = null; flushCart(); }
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        if (cartIdle() || tries++ > 100) resolve();
        else setTimeout(check, 40);
      })();
    });
  }

  function findLineNode(list, key) {
    var nodes = $$('[data-line-item]', list);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-line-key') === String(key)) return nodes[i];
    }
    return null;
  }

  function insertLineNode(item, optimistic) {
    var list = $('[data-mgm-line-items]', root);
    var tpl = $('[data-mgm-tpl="line-item"]', root);
    if (!list || !tpl) return null;

    list.hidden = false;
    var empty = $('[data-mgm-cart-empty]', root);
    if (empty) empty.hidden = true;

    var node = tpl.content.firstElementChild.cloneNode(true);
    node.setAttribute('data-recon-key', String(item.key));
    if (optimistic) node.setAttribute('data-optimistic', '');
    fillLineItem(node, item);
    list.appendChild(node);
    return node;
  }

  function optimisticItem(offer) {
    var cents = function (v) { return Math.round((v || 0) * 100); };
    return {
      key: 'temp:' + offer.variant_id + ':' + Date.now(),
      variant_id: offer.variant_id,
      handle: offer.handle || '',
      quantity: 1,
      image: offer.image,
      product_title: offer.title,
      title: offer.title,
      variant_title: null,
      currency: offer.currency,
      final_line_price: cents(offer.price),
      line_price: cents(offer.price),
      original_line_price: cents(offer.compare_price || offer.price)
    };
  }

  function firstAddedItem(res) {
    if (Array.isArray(res)) return res[0];
    if (res && res.items) return res.items[0];
    if (res && res.key) return res;
    return null;
  }

  function handleAdd(offer, button) {
    if (!offer || !button) return;

    var card = button.closest('[data-mgm-offer-card]');
    if (card) {
      var oid = card.getAttribute('data-offer-id');
      if (oid) {
        var io = getImpressionObserver();
        if (io) io.unobserve(card);
        seenOffers.delete(oid);
      }
      collapseRemove(card);
    }

    var tempNode = insertLineNode(optimisticItem(offer), true);
    recomputeTotalsOptimistic();

    MGMFunnel.addUpsell(offer, STAGE_DRAWER).then(function (res) {
      var real = firstAddedItem(res);
      if (real) {
        var list = $('[data-mgm-line-items]', root);
        var dup = list && findLineNode(list, real.key);
        if (dup && dup !== tempNode) {
          if (tempNode && tempNode.parentNode) tempNode.parentNode.removeChild(tempNode);
        } else if (tempNode) {
          tempNode.removeAttribute('data-optimistic');
          tempNode.setAttribute('data-recon-key', String(real.key));
          fillLineItem(tempNode, real);
        } else {
          insertLineNode(real);
        }
      }
      MGMFunnel.event(currentCartToken, offer, STAGE_DRAWER, 'accept', offer.price);
      scheduleOfferRefresh(null);
    }).catch(function (e) {
      console.warn('[MGM] add failed', e);
      if (tempNode && tempNode.parentNode) tempNode.parentNode.removeChild(tempNode);
      recomputeTotalsOptimistic();
      scheduleOfferRefresh(null);
    });
  }

  function handleBundleToggle(offer, card) {
    if (!offer || !card) return;
    if (card.getAttribute('data-selected') === 'true') bundleDeselect(offer, card);
    else bundleSelect(offer, card);
  }

  function bundleSelect(offer, card) {
    bundleSelectedIds.add(String(offer.offer_id));
    setBundleSelected(card, true);
    card.__mgmPending = true;
    var tempNode = insertLineNode(optimisticItem(offer), true);
    card.__mgmTempNode = tempNode;
    recomputeTotalsOptimistic();

    MGMFunnel.addUpsell(offer, STAGE_DRAWER).then(function (res) {
      var real = firstAddedItem(res);
      var list = $('[data-mgm-line-items]', root);
      if (real) {
        var dup = list && findLineNode(list, real.key);
        if (dup && dup !== tempNode) {
          if (tempNode && tempNode.parentNode) tempNode.parentNode.removeChild(tempNode);
        } else if (tempNode) {
          tempNode.removeAttribute('data-optimistic');
          tempNode.setAttribute('data-recon-key', String(real.key));
          fillLineItem(tempNode, real);
        } else {
          insertLineNode(real);
        }
        card.__mgmTempNode = null;
        if (card.getAttribute('data-selected') !== 'true') {
          var stale = list && findLineNode(list, real.key);
          if (stale) collapseRemove(stale);
          card.__mgmPending = false;
          recomputeTotalsOptimistic();
          queueCartChange(real.key, 0, true);
          return;
        }
        card.setAttribute('data-line-key', String(real.key));
      }
      card.__mgmPending = false;
      MGMFunnel.event(currentCartToken, offer, STAGE_DRAWER, 'accept', offer.price);
      scheduleOfferRefresh(null);
    }).catch(function (e) {
      console.warn('[MGM] add failed', e);
      if (tempNode && tempNode.parentNode) tempNode.parentNode.removeChild(tempNode);
      card.__mgmTempNode = null;
      card.__mgmPending = false;
      bundleSelectedIds.delete(String(offer.offer_id));
      setBundleSelected(card, false);
      recomputeTotalsOptimistic();
      scheduleOfferRefresh(null);
    });
  }

  function bundleDeselect(offer, card) {
    bundleSelectedIds.delete(String(offer.offer_id));
    setBundleSelected(card, false);
    var key = card.getAttribute('data-line-key');
    card.removeAttribute('data-line-key');
    var list = $('[data-mgm-line-items]', root);
    if (key) {
      var node = list && findLineNode(list, key);
      if (node) collapseRemove(node);
      card.__mgmPending = false;
      recomputeTotalsOptimistic();
      queueCartChange(key, 0, true);
    } else if (card.__mgmTempNode) {
      var t = card.__mgmTempNode;
      if (t && t.parentNode) t.parentNode.removeChild(t);
      card.__mgmTempNode = null;
      recomputeTotalsOptimistic();
    }
  }

  function bindRoot(el) {
    root = el;
    var initial = el.getAttribute('data-cart-state') || STATE.BUNDLE;
    setView(initial);
    setupDragToDismiss(el);

    el.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-cart-close]')) { close(); return; }

      var checkout = t.closest('[data-cart-checkout]');
      if (checkout) {
        if (checkout.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
        if (!cartIdle()) {
          e.preventDefault();
          var href = checkout.getAttribute('href') || '/checkout';
          flushCartNow().then(function () { window.location.href = href; });
        }
        return;
      }

      var stateBtn = t.closest('[data-cart-goto]');
      if (stateBtn) { setView(stateBtn.getAttribute('data-cart-goto')); return; }

      var dealToggle = t.closest('[data-deal-toggle]');
      if (dealToggle) {
        dealToggle.classList.remove('is-hint');
        var deal = dealToggle.closest('[data-deal]');
        if (deal) {
          var openNow = deal.getAttribute('data-deal-open') === 'true';
          deal.setAttribute('data-deal-open', openNow ? 'false' : 'true');
          dealToggle.setAttribute('aria-expanded', openNow ? 'false' : 'true');
        }
        return;
      }

      var tabBtn = t.closest('[data-deal-tab]');
      if (tabBtn) {
        var dealEl = tabBtn.closest('[data-deal]');
        if (!dealEl) return;
        var id = tabBtn.getAttribute('data-deal-tab');
        $$('[data-deal-tab]', dealEl).forEach(function (b) {
          b.setAttribute('aria-selected', b === tabBtn ? 'true' : 'false');
        });
        $$('[data-deal-panel]', dealEl).forEach(function (p) {
          if (p.getAttribute('data-deal-panel') === id) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
        return;
      }

      var addBtn = t.closest('[data-mgm-action="add"]');
      if (addBtn) {
        e.preventDefault();
        var card = addBtn.closest('[data-mgm-offer-card]');
        if (!card) return;
        var oid = card.getAttribute('data-offer-id');
        var offer = oid && seenOffers.get(oid);
        if (!offer) return;
        if (card.hasAttribute('data-bundle-item')) handleBundleToggle(offer, card);
        else handleAdd(offer, addBtn);
        return;
      }

      var qty = t.closest('[data-cart-qty]');
      if (qty) {
        var dir = qty.getAttribute('data-cart-qty');
        var item = qty.closest('[data-line-item]');
        if (!item) return;
        var valueEl = $('[data-cart-qty-value]', item);
        var value = parseInt(valueEl.textContent, 10) || 1;
        var next = dir === 'inc' ? value + 1 : Math.max(1, value - 1);
        var key = item.getAttribute('data-line-key');
        updateQtyUI(item, next);
        optimisticLinePrice(item, next);
        recomputeTotalsOptimistic();
        if (key) queueCartChange(key, next, false);
        return;
      }

      var trash = t.closest('[data-cart-remove]');
      if (trash) {
        var li = trash.closest('[data-line-item]');
        if (!li) return;
        var giftNs = li.getAttribute('data-gift-ns');
        if (giftNs && window.MGMGift) MGMGift.decline(giftNs);
        var lkey = li.getAttribute('data-line-key');
        collapseRemove(li);
        recomputeTotalsOptimistic();
        if (lkey) queueCartChange(lkey, 0, true);
        return;
      }
    });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function setupDragToDismiss(el) {
    if (el.__mgmDragInit) return;
    el.__mgmDragInit = true;
    var panel = el.querySelector('.mgm-cart-drawer__panel');
    var backdrop = el.querySelector('.mgm-cart-drawer__backdrop');
    if (!panel) return;

    var startY = 0;
    var lastY = 0;
    var lastT = 0;
    var velocity = 0;
    var dragId = null;
    var started = false;
    var THRESHOLD_START = 8;
    var CLOSE_RATIO = 0.3;
    var CLOSE_VELOCITY = 0.5;

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function onDown(e) {
      if (!isMobile()) return;
      if (!el.classList.contains('is-open')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (!e.target.closest('[data-drag-handle]')) return;
      dragId = e.pointerId;
      startY = e.clientY;
      lastY = startY;
      lastT = e.timeStamp;
      velocity = 0;
      started = false;
    }

    function onMove(e) {
      if (dragId !== e.pointerId) return;
      var dy = e.clientY - startY;
      if (!started) {
        if (Math.abs(dy) < THRESHOLD_START) return;
        started = true;
        el.classList.add('is-dragging');
        if (panel.setPointerCapture) {
          try { panel.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      if (dy < 0) dy = 0;
      var now = e.timeStamp;
      var dt = now - lastT;
      if (dt > 0) velocity = (e.clientY - lastY) / dt;
      lastY = e.clientY;
      lastT = now;
      panel.style.transform = 'translateY(' + dy + 'px)';
      if (backdrop) {
        var h = panel.offsetHeight || 1;
        var progress = Math.min(1, dy / h);
        backdrop.style.opacity = String(1 - progress * 0.85);
      }
    }

    function finish(shouldClose) {
      el.classList.remove('is-dragging');
      panel.style.transform = '';
      if (backdrop) backdrop.style.opacity = '';
      if (shouldClose) close();
    }

    function onUp(e) {
      if (dragId !== e.pointerId) return;
      dragId = null;
      if (!started) return;
      started = false;
      var dy = Math.max(0, lastY - startY);
      var h = panel.offsetHeight || 1;
      var shouldClose = dy > h * CLOSE_RATIO || velocity > CLOSE_VELOCITY;
      finish(shouldClose);
    }

    function onCancel(e) {
      if (dragId !== e.pointerId) return;
      dragId = null;
      if (!started) return;
      started = false;
      finish(false);
    }

    el.addEventListener('pointerdown', onDown, { passive: true });
    el.addEventListener('pointermove', onMove, { passive: true });
    el.addEventListener('pointerup', onUp, { passive: true });
    el.addEventListener('pointercancel', onCancel, { passive: true });
  }

  function schedulePrefetch() {
    var run = function () { prefetch(); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 4000 });
    } else {
      setTimeout(run, 1500);
    }
  }

  var openersBound = false;
  function bindOpeners() {
    if (openersBound) return;
    openersBound = true;

    document.addEventListener('product:added-to-cart', function () {
      open(STATE.BUNDLE);
    });

    window.addEventListener('click', function (e) {
      var cartBtn = e.target && e.target.closest && e.target.closest('.brand-header__cart');
      if (!cartBtn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open(STATE.CART);
    }, true);
  }

  function init() {
    var el = document.querySelector('[data-cart-drawer]');
    if (!el) return;
    if (el.__mgmCartInit) return;
    el.__mgmCartInit = true;

    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }

    bindRoot(el);
    bindOpeners();

    var params = new URLSearchParams(window.location.search);
    var preview = params.get('cart-drawer-preview') || el.getAttribute('data-cart-preview');
    if (preview === 'bundle' || preview === 'cart') {
      requestAnimationFrame(function () { open(preview); });
    } else {
      if (document.readyState === 'complete') schedulePrefetch();
      else window.addEventListener('load', schedulePrefetch, { once: true });
    }
  }

  window.MGMCartDrawer = {
    open: open,
    close: close,
    setView: setView,
    refresh: hydrate,
    STATE: STATE
  };

  document.addEventListener('mgm:gift:synced', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !root) return;
    renderCartImmediate(cart);
    updateShippingFromCart(cart);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-cart-drawer]')) {
      var el = e.target.querySelector('[data-cart-drawer]');
      el.__mgmCartInit = false;
      init();
    }
  });
})();
